import { createFileRoute } from '@tanstack/react-router';
import { RequireService } from '@/components/shared/require-service';
import { VehiclesPage as VehiclesPageContent } from '@/features/debtors/vehicles-page';

/**
 * fuel.md section 5.4: not in the nav — reachable only from a debtor row's
 * **المركبات** action, and active under عملاء الذمم there because
 * `isNavItemActive` treats it as a prefix of `/debtors`.
 */
function VehiclesPage() {
  const { debtorId } = Route.useParams();
  return (
    <RequireService service="DEBTOR_VIEW">
      <VehiclesPageContent debtorId={debtorId} />
    </RequireService>
  );
}

export const Route = createFileRoute('/_app/debtors/$debtorId/vehicles')({
  component: VehiclesPage,
});
